import { createAction, props } from '@ngrx/store';
import { FiltersDto } from '@shared/models/interfaces/filters.interface';

import * as ActionTypes from './activity-payments-filters.actionTypes';

export const loadPaymentsFilters = createAction(ActionTypes.LOAD_PAYMENTS_FILTERS);
export const updatePaymentsFilters = createAction(ActionTypes.UPDATE_PAYMENTS_FILTERS, props<{ paymentsFilters: FiltersDto }>());
